<template>
  <div>
    <section class="section team">
      <div class="container items-center">
        <vs-row vs-type="flex" vs-justify="space-around">
          <vs-col
            class="sm:w-full lg:w-1/3"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <div class="shift_right">
              <h6 class="section__title1 team-txt pos_abs mb-2">Team</h6>
              <h3 class="section__heading1 team-sub pos_abs mb-5">
                We’ve <br />
                Assembled A <br />
                Great Team
              </h3>
              <!-- <p class="section__p mb-base">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                luctus mi metus, egestas scelerisque
              </p> -->
            </div>
          </vs-col>
          <vs-col class="sm:w-full lg:w-2/3">
          <vs-row vs-justify="center">
            <vs-col
              class="sm:w-full lg:w-2/5 mb-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="vx-card team_card no-shadow">
                <div class="vx">
                  <div class="p-6 flex items-center">
                    <span
                      class="
                        inline-flex
                        rounded-full
                        feather-icon
                        select-none
                        relative
                        text-primary
                      "
                      style="background: rgba(var(--vs-success), 0)"
                    >
                    <a id="linkShivam" :href="linkShivam" target="_blank"
                      ><img id="img1" :src="img_shivam" alt="About Us" width="60px" height="60px" />
                      <img class="linkdin" src="@/assets/images/aboutUs/linkdin.png" alt="About Us" /></a>
                      
                    </span>
                    <div class="truncate items-left">
                      <h5 class="mb-1 shivam">Shivam Dhawan</h5>
                      <span class="position founder">Founder/CEO</span>
                    </div>
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col
              class="sm:w-full lg:w-2/5 mb-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="vx-card team_card no-shadow">
                <div class="vx">
                  <div class="p-6 flex items-center">
                    <span
                      class="
                        inline-flex
                        rounded-full
                        feather-icon
                        select-none
                        relative
                        text-primary
                      "
                      style="background: rgba(var(--vs-success), 0)"
                    >
                      <a id="linkRamji" :href="linkRamji" target="_blank">
                      <img id="img2" :src="img_ramji" alt="About Us" width="60px" height="60px" />
                      <img class="linkdin" src="@/assets/images/aboutUs/linkdin.png" alt="About Us" /></a>
                     
                    </span>
                    <div class="truncate items-left">
                      <h5 class="mb-1 ramji">Ramji Gupta</h5>
                      <span class="position backend">DPO</span>
                    </div>
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col
              class="sm:w-full lg:w-2/5 mb-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="vx-card team_card no-shadow">
                <div class="vx">
                  <div class="p-6 flex items-center">
                    <span
                      class="
                        inline-flex
                        rounded-full
                        feather-icon
                        select-none
                        relative
                        text-primary
                      "
                      style="background: rgba(var(--vs-success), 0)"
                    >
                      <a id="linkJyoti" :href="linkJyoti" target="_blank">
                      <img id="img3" :src="img_jyoti" alt="About Us" width="60px" height="60px" />
                      <img class="linkdin" src="@/assets/images/aboutUs/linkdin.png" alt="About Us" /></a>
                      
                    </span>
                    <div class="truncate items-left">
                      <h5 class="mb-1 jyoti">Jyoti Sing</h5>
                      <span class="position creative">Creative Director</span>
                    </div>
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col
              class="sm:w-full lg:w-2/5 card_hide mb-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="vx-card team_card no-shadow">
                <div class="vx">
                  <div class="p-6 flex items-center">
                    <span
                      class="
                        inline-flex
                        rounded-full
                        feather-icon
                        select-none
                        relative
                        text-primary
                      "
                      style="background: rgba(var(--vs-success), 0)"
                    >
                      <a id="linkSumit" :href="linkSumit" target="_blank">
                      <img id="img6" :src="img_sumit" alt="About Us" width="60px" height="60px" />
                      <img class="linkdin" src="@/assets/images/aboutUs/linkdin.png" alt="About Us" /></a>
                      
                    </span>
                    <div class="truncate items-left">
                      <h5 class="mb-1 sumit">Sumit Rathore</h5>
                      <span class="position ai">AI Director</span>
                    </div>
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col
              class="sm:w-full lg:w-2/5 card_hide mb-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="vx-card team_card no-shadow">
                <div class="vx">
                  <div class="p-6 flex items-center">
                    <span
                      class="
                        inline-flex
                        rounded-full
                        feather-icon
                        select-none
                        relative
                        text-primary
                      "
                      style="background: rgba(var(--vs-success), 0)"
                    >
                      <a href="https://www.linkedin.com/in/maria-jo%C3%A3o-silva-068119175/" target="_blank"><img id="img5" src="@/assets/images/team_members/Maria_gr.jpg" alt="maria" width="60px" height="60px" />
                      <img class="linkdin" src="@/assets/images/aboutUs/linkdin.png" alt="About Us" /></a>
                      
                    </span>
                    <div class="truncate items-left">
                      <h5 class="mb-1 alex">Maria Silva</h5>
                      <span class="position blockchain">Community Management</span>
                    </div>
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col
              class="sm:w-full lg:w-2/5 card_hide mb-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="vx-card team_card no-shadow">
                <div class="vx">
                  <div class="p-6 flex items-center">
                    <span
                      class="
                        inline-flex
                        rounded-full
                        feather-icon
                        select-none
                        relative
                        text-primary
                      "
                      style="background: rgba(var(--vs-success), 0)"
                    >
                      <a href="https://www.linkedin.com/in/martasoaresmatias/" target="_blank"><img id="img5" src="@/assets/images/team_members/Marta_gr.jpg" alt="marta" width="60px" height="60px" />
                      <img class="linkdin" src="@/assets/images/aboutUs/linkdin.png" alt="About Us" /></a>
                      
                    </span>
                    <div class="truncate items-left">
                      <h5 class="mb-1 alex">Marta Matias</h5>
                      <span class="position blockchain">Client Management</span>
                    </div>
                  </div>
                </div>
              </div>
            </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </section>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  ScrollTrigger,
  name: "Advisors",
  data() {
    return {
      hello: 'true',
      img_shivam: require("@/assets/images/team_members/Shivam_gr.jpg"),
      linkShivam: 'https://www.linkedin.com/in/shivamdhawan/',
      img_ramji: require("@/assets/images/team_members/ramji.png"),
      linkRamji: 'https://www.linkedin.com/in/ramji-gupta-029492131/',
      img_jyoti: require("@/assets/images/team_members/jyoti.png"),
      linkJyoti: 'https://www.linkedin.com/in/jyotising/',
      img_srajan: require("@/assets/images/team_members/srajan.png"),
      linkSrajan: 'https://www.linkedin.com/in/srajangupta/',
      img_alex: require("@/assets/images/team_members/alex.png"),
      img_sumit: require("@/assets/images/team_members/sumit.png"),
      linkSumit: 'https://www.linkedin.com/in/sumit-rathore-19ba01140/',
      img_martin: require("@/assets/images/advisors/martin-sutherland.png"),
      linkMartin: 'https://www.linkedin.com/in/martin-sutherland-979bb58/',
      img_brett: require("@/assets/images/advisors/brett-mulder.png"),
      linkBrett: 'https://www.linkedin.com/in/brett-mulder/',
      img_wolfaardt: require("@/assets/images/advisors/martin-wolfaardt.png"),
      linkWolfaardt: 'https://www.linkedin.com/in/martin-wolfaardt-aa28034b/',
      img_suhas: require("@/assets/images/advisors/suhas-bendre.png"),
      linkSuhas: 'https://www.linkedin.com/in/suhas-bendre/',

      advisors: [
        {
          id: 1,
          mentor_name: "Martin Sutherland",
          position: "Business Mentor",
          icon: require("@/assets/images/advisors/martin-sutherland.png"),
          icon1: require("@/assets/images/advisors/martin-sutherland.png"),
        },
        {
          id: 2,
          mentor_name: "Brett Mulder",
          position: "Business Mentor",
          icon: require("@/assets/images/advisors/brett-mulder.png"),
        },
        {
          id: 3,
          mentor_name: "Martin Wolfaardt",
          position: "Business Mentor",
          icon: require("@/assets/images/advisors/martin-wolfaardt.png"),
        },
        {
          id: 4,
          mentor_name: "Suhas Bendre",
          position: "Cognizant Director Operations Advisor",
          icon: require("@/assets/images/advisors/suhas-bendre.png"),
        },
      ],

      team_members: [
        {
          id: 1,
          member_name: "Shivam Dhawan",
          position: "Co-Founder/CEO",
          icon: require("@/assets/images/team_members/shivam.png"),
        },
        {
          id: 2,
          member_name: "Ramji Gupta",
          position: "Backend Developer",
          icon: require("@/assets/images/team_members/ramji.png"),
        },
        {
          id: 3,
          member_name: "Jyoti Sing",
          position: "Creative Director",
          icon: require("@/assets/images/team_members/jyoti.png"),
        },
        {
          id: 4,
          member_name: "Sumit Rathore",
          position: "AI Director",
          icon: require("@/assets/images/team_members/sumit.png"),
        },
        {
          id: 5,
          member_name: "Srajan Gupta",
          position: "Innovative Director",
          icon: require("@/assets/images/team_members/srajan.png"),
        },
        {
          id: 6,
          member_name: "Alex Wilson",
          position: "Blockchain Developer",
          icon: require("@/assets/images/team_members/alex.png"),
        },
      ],
    };
  },
  methods: {
    advisorsAnimation() {
      
    
    // const t5 = this.img_suhas; 
    // console.log(this.hello);
          
    ScrollTrigger.matchMedia({
      "(min-width: 992px)": function () {
          let t1 = gsap.timeline({
            scrollTrigger: {
              trigger: ".team",
              scrub: 0.2,
              pin: true,
              start: "top top",
              pinSpacing: false,
              end: "100%",
              // markers:true //(for debugging scroll function)
            },
          });

          // console.log(t5);
          // t1.from(".linkdin", { opacity: 0, duration: 0, stagger:.5 }, "a");
            t1.to('body', {duration: 1})
            .set('.section__title1', { innerHTML: "Mentors"}, 20)
            .set('.section__title1', { color: "#5585ff"}, 20)
            ;

            // t1.from(".linkdin", { opacity: 0, duration: 0, stagger:0.15 }, "a");
            t1.set('.section__heading1', { innerHTML: "We’ve <br/> Great Mentors<br/> With Us"}, 20);
              
            t1.set('#img1', { attr: { src:'https://i.ibb.co/zx42BQ0/Martin-Sutherland.jpg' } });
            t1.set('#linkShivam', { attr: { href:'https://www.linkedin.com/in/martin-sutherland-979bb58/' } });
            t1.set('.shivam', { innerHTML: "Martin Sutherland"}, 20);
            t1.set('.founder', { innerHTML: "Business Mentor"}, 20);
            t1.set('.position', { color: '#44cc88'}, 20);

            t1.set('#img2', { attr: { src:'https://i.ibb.co/J5mhtJy/Brett-mulder.jpg' } });
            t1.set('#linkRamji', { attr: { href:'https://www.linkedin.com/in/brett-mulder/' } });
            t1.set('.ramji', { innerHTML: "Brett Mulder"}, 20);
            t1.set('.backend', { innerHTML: "Business Mentor"}, 20);

            t1.set('#img3', { attr: { src:'/img/martin-wolfaardt.5c494385.png' } });
            t1.set('#linkJyoti', { attr: { href:'https://www.linkedin.com/in/martin-wolfaardt-aa28034b/' } });
            t1.set('.jyoti', { innerHTML: "Martin Wolfaardt"}, 20);
            t1.set('.creative', { innerHTML: "Business Mentor"}, 20);

            // t1.set('#img4', { attr: { src:'/img/suhas-bendre.c886e157.png' } });
            // t1.set('#linkSrajan', { attr: { href:'https://www.linkedin.com/in/suhas-bendre/' } });
            // t1.set('.srajan', { innerHTML: "Suhas Bendre"}, 20);
            // t1.set('.innovative', { innerHTML: "Operations Advisor"}, 20);
            // t1.to('.linkdin', {opacity:0, duration:1});

        // t1.to(".team", { opacity: 0, duration: 1 }, "a");
        t1.to(".vx", { opacity: 0, duration: 1, stagger:3 }, "a");
        t1.to(".vx", { opacity: 1, duration: 1, stagger:3 }, "a");
        t1.to(".card_hide", { opacity: 0, duration: 1, stagger:2 }, "a");
        t1.to({}, {duration:6});
      },
    });
    }
  },
  mounted() {
    this.advisorsAnimation();
  },
};
</script>

<style scoped>
/* .vx, .vx1{
  position: absolute;
} */
#img1, #img2, #img5{
  border-radius: 50%;
}
.linkdin {
  position: absolute;
    right: -2px;
    bottom: -9px;
}
.truncate h5 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 140%;
  color: #121127;
}
.position {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 180%;
  color: #5585ff;
}
.section {
  height: 100vw;
}
.container {
  padding: 4rem 0 10rem 6rem;
}
.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
section {
  padding: 5rem;
}
.section__heading1 {
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 140%;
  color: #121127;
  text-align: left;
}
.section__p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 180%;
  color: #5d6473;
  text-align: left;
}
.section__title1 {
  text-align: left;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 170%;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #44cc88;
}
.truncate {
  width: 80%;
  white-space: normal !important;
  margin-left: 1.5rem;
}

.team_card {
  background: #f8f8f8;
}

/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
  section {
    padding: 5rem 2rem;
    background: #ffffff;
  }
  .section__p {
    width: -webkit-fill-available;
    width: -moz-available;
  }
  .section {
    height: auto;
  }
  .container {
    padding: 2rem 2rem;
  }
}
</style>
